/**
 * Stable CSS class names for E2E / automation — Cookie Type.
 */
export const CKT = {
    page: 'cookie-type-page',
    titleArea: 'cookie-type-page__title',
    toolbar: 'cookie-type-page__toolbar',
    datagrid: 'cookie-type-page__datagrid',

    input: 'cookie-type-input',
    inputButton: 'cookie-type-input--button',
    inputSwitch: 'cookie-type-input--switch',
    inputIconButton: 'cookie-type-input--icon-button',
    inputMenuItem: 'cookie-type-input--menu-item',
    inputSelect: 'cookie-type-input--select',
    inputTextfield: 'cookie-type-input--textfield',

    btnAddCookieType: 'cookie-type-field--add-cookie-type',
    gridSwitchStatus: 'cookie-type-field--grid-status',

    rowActionsTrigger: 'cookie-type-field--row-actions-trigger',
    rowActionEdit: 'cookie-type-field--row-action-edit',

    drawer: 'cookie-type-drawer',
    drawerHeader: 'cookie-type-drawer__header',
    drawerClose: 'cookie-type-drawer__close',
    drawerBody: 'cookie-type-drawer__body',
    drawerActions: 'cookie-type-drawer__actions',

    fieldCookieTypeName: 'cookie-type-field--cookie-type-name',
    fieldCookieTypeDescription: 'cookie-type-field--cookie-type-description',
    fieldCookieTypeId: 'cookie-type-field--cookie-type-id',
    fieldPriority: 'cookie-type-field--priority',
    fieldStatusSelect: 'cookie-type-field--status-select',

    btnDrawerSave: 'cookie-type-field--drawer-save',
    btnDrawerUpdate: 'cookie-type-field--drawer-update',
} as const;

export const cktCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
